import GMPAPI from "../../services/gmpapi";
import DataStore from "../../store";
import { DumpError } from "../../utilities";

import SubpageDashboard from "./accountdashboard/SubpageDashboard.vue";
import SubpageBillingPayment from "./billingpayment/SubpageBillingPayment.vue";
import SubpageUsage from "./usage/SubpageUsage.vue";
import SubpageNotifications from "./notifications/SubpageNotifications.vue";
import SubpageAccountSettings from "./accountsettings/SubpageAccountSettings.vue";
import SubpageNetMetering from "./netmetering/SubpageNetMetering.vue";

import SubpageOverview from "./billingpayment/SubpageOverview.vue";
import SubpageReport from "./billingpayment/SubpageReport.vue";
import SubpagePreferences from "./billingpayment/SubpagePreferences.vue";
import SubpageSavedPayments from "./billingpayment/SubpageSavedPayments.vue";

export const MyAccountRouterOptions = {
  mode: "history",
  base: "/account",
  // If passed a hash, scroll to the hash. Otherwise, scroll to the top.
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    { path: "/", component: SubpageDashboard },
    {
      path: "/billing", component: SubpageBillingPayment,
      children: [
        { path: "/", component: SubpageOverview },
        { path: "/report", component: SubpageReport },
        { path: "/preferences", component: SubpagePreferences },
        { path: "/saved-payments", component: SubpageSavedPayments },
      ]
    },
    { path: "/netmetering", component: SubpageNetMetering },
    { path: "/usage", component: SubpageUsage },
    { path: "/notifications", component: SubpageNotifications },
    { path: "/settings", component: SubpageAccountSettings },
    { path: "*", redirect: "/" },
  ],
};

let knownLoggedIn = false;

export function MyAccountRouterInit(router) {
  // Enforce required login before showing my account
  router.beforeEach(async (to, from, next) => {
    if (knownLoggedIn) {
      next();
    } else {
      try {
        DataStore.commit("setRouteLoading", true);
        await GMPAPI.GetCurrentUser();
        // We have auth, but may not have user info
        if (!DataStore.state.user.userinfo) {
          try {
            await DataStore.dispatch("AttemptCookieLogin");
            // Set this, so we don't try to verify login on every route change
            knownLoggedIn = true;
            next();
          } catch (err) {
            window.location.href = "/transit-login?redirect=" + encodeURIComponent(window.location.pathname + window.location.hash + window.location.search);
          }
        } else {
          // Set this, so we don't try to verify login on every route change
          knownLoggedIn = true;
          next();
        }
      } catch (err) {
        if (!(err.response && err.response.status === 401)) {
          DumpError("Account routing error", err);
        }
        window.location.href = "/transit-login?redirect=" + encodeURIComponent(window.location.pathname + window.location.hash + window.location.search);
      } finally {
        DataStore.commit("setRouteLoading", false);
      }
    }
  });
}